const catchMePigClassNames = ['red', 'blue', 'yellow'];
const touchMePigClassNames = ['blue', 'red', 'yellow'];

export { catchMePigClassNames, touchMePigClassNames };
